import type { OnboardingState } from '@geo-admin/shared/contract/api/metrics.ts';

/**
 * 온보딩 쓰로틀링 상태 (260921-report-snapshot-and-onboarding-throttle).
 * 계약상 **운영자에게만** 내려오므로 고객 화면에서는 아무것도 그리지 않는다.
 *
 * ★ 분모는 **그 행에 박힌 기간**(`state.days`)이다 — 상수도, 질문의 현재 설정도 아니다
 *   (261001-onboarding-period-per-query). 기간은 질문마다 다르고, 바꿔도 과거 행은 안 움직인다
 */
export function OnboardingCell({ state }: { state: OnboardingState | null }) {
  if (!state) return null;
  if (!state.enabled) return <span className="text-xs text-slate-400">미적용</span>;
  if (state.day === null) return <span className="text-xs text-slate-400">—</span>;
  return (
    <div className="leading-tight tabular-nums">
      <div className="text-xs">
        {state.day}/{state.days ?? '?'}일차
      </div>
      <div className="text-xs text-slate-500">×{state.factor?.toFixed(3) ?? '?'}</div>
    </div>
  );
}
